import { useParams } from "react-router-dom";
import TestOffersList from "./List.jsx";
import TestOffersDetail from "./Detail.jsx";

const TestOffersPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? TestOffersDetail : TestOffersList;

    return <Specified />;
};

export default TestOffersPage;
